import ActionColumnComponent from "../../components/ActionColumn/ActionColumn";

export const importantDocCols = (viewModal, updateModal, deleteRecord) => {
  const actionColumn = ActionColumnComponent({ viewModal, updateModal, deleteRecord });

  return {
    "Birth Certificate": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Social Security Cards": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    Passport: [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Driver License": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Marriage Certificate": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Military Records": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Living Will": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Living Trust": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Power of Attorney": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Insurance Policy": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Vehicle Titles": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Educational Records": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
    "Vaccination Records": [
      {
        title: "Document Name",
        dataIndex: "Document Name",
        key: "documentname",
      },
      {
        title: "Who's Document",
        dataIndex: "Who's Document",
        key: "whosdocument",
      },
      {
        title: "Expiration Data",
        dataIndex: "Expiration Data",
        key: "expirationdate",
      },
      actionColumn,
    ],
  };
};
